import React from 'react';
import './Highspeedsensiti.css';
import injectImage from '../../../imgs/higtspeedsensi.webp';
import beltImage from '../../../imgs/ultrahigh.webp';

const Highspeedsensiti = () => {
    return (
        <div className="inject-wrapper">
            <div className="inject-container">
                <div className="inject-text">
                    <h2>INJECTION SYSTEM</h2>
                    <h3>-High Speed & Sensitivity</h3>
                    <p>
                        Injection system with full-electric design, fast injection, high stability,
                        high sensitivity, high durability. With ultra-high torque belt, small deformation,
                        high repetition accuracy, ultra-high hardness aluminum alloy pulley, small inertia, fast response.
                    </p>

                    <div className="inject-gallery">
                        <img src={beltImage} alt="Torque Belt" className="highsped" />
                    </div>
                </div>

                <div className="inject-image">
                    <img src={injectImage} alt="Injection System"  />
                </div>
            </div>
        </div>
    );
};

export default Highspeedsensiti;
